module.exports = __webpack_public_path__ + "static/media/home-1.0ec375fd.svg";